var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/flask") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/flask",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8728173,16.0756701 C20.8238062,18.2962763 19.9640137,20.316684 18.5786944,21.8541139 C18.0592102,22.4302882 17.3102801,22.7499934 16.5342847,22.7499934 L7.33727375,22.7499934 C6.57327944,22.7499934 5.83118908,22.443632 5.31774731,21.8777383 C3.87783604,20.2917588 3,18.1862951 3,15.8750098 C3,12.4323568 4.95981512,9.46621927 7.81248853,7.97393996 L7.81248853,4.87503606 L10.562482,4.87503606 L10.562482,9.63855543 C9.69408728,10.0931671 6.2514342,11.303129 5.79942417,15.1625863 C8.62889283,13.7480618 11.2839272,13.8292574 13.6111159,14.9928518 C15.5442854,15.9596463 17.1052978,15.8750098 18.1163618,15.8750098 C18.1047804,11.928776 14.8795302,10.5000684 13.312895,9.65743814 L13.312895,4.87503606 L16.0628885,4.87503606 L16.0628885,8.01388737 C18.9495507,9.56633957 20.9484321,12.6403183 20.8728173,16.0756701 Z M7.12499017,3.50003934 C6.74515403,3.50003934 6.4374918,3.19237711 6.4374918,2.81254098 L6.4374918,1.43754426 C6.4374918,1.05770813 6.74515403,0.750045896 7.12499017,0.750045896 L16.7499672,0.750045896 C17.1298033,0.750045896 17.4374656,1.05770813 17.4374656,1.43754426 L17.4374656,2.81254098 C17.4374656,3.19237711 17.1298033,3.50003934 16.7499672,3.50003934 L7.12499017,3.50003934 Z",
    id: "flask",
    fill: "#40B3DB",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlask);
export default __webpack_public_path__ + "static/media/flask.ad7b8f8c.svg";
export { ForwardRef as ReactComponent };